import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { ChartContainer } from "@/components/charts/ChartContainer";
import { formatCurrency } from "@/utils/format";
import { PieActiveSector } from "@/utils/rechartsInteraction";

const COLORS = [
  "#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444",
  "#06b6d4", "#84cc16", "#f97316", "#ec4899", "#6366f1",
];

interface TipProps {
  active?:  boolean;
  payload?: { name: string; value: number; payload: { pct: number } }[];
}
function CustomTooltip({ active, payload }: TipProps) {
  if (!active || !payload?.length) return null;
  const { name, value, payload: p } = payload[0];
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-lg p-3 min-w-[200px]">
      <p className="text-xs font-bold text-slate-700 mb-1 truncate">{name}</p>
      <div className="flex items-center justify-between text-sm gap-4">
        <span className="text-slate-500">Orçado</span>
        <span className="font-semibold text-slate-800">{formatCurrency(value, true)}</span>
      </div>
      <div className="flex items-center justify-between text-xs mt-1">
        <span className="text-slate-500">Participação</span>
        <span className="font-bold text-brand-600">{p.pct.toFixed(1)}%</span>
      </div>
    </div>
  );
}

interface DataPoint { name: string; value: number; pct: number }

interface Props {
  data:    DataPoint[];
  loading: boolean;
}

export function DistribuicaoOrcamento({ data, loading }: Props) {
  return (
    <ChartContainer
      title="Distribuição do Orçamento"
      subtitle="Participação de cada unidade construtiva no orçamento total"
      loading={loading}
      empty={!loading && data.length === 0}
      height={320}
    >
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="44%"
          innerRadius="60%"
          outerRadius="92%"
          paddingAngle={2}
          dataKey="value"
          activeShape={PieActiveSector}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: 10, paddingTop: 10 }}
          iconType="circle"
          iconSize={8}
          formatter={(value: string) =>
            value.length > 22 ? value.slice(0, 20) + "…" : value
          }
        />
      </PieChart>
    </ChartContainer>
  );
}
